import { isEmpty, merge } from "lodash";

type EpfPortal = {
    EPF: {
        THIRDPARTY: {
            TOKENS: {
                tokenWrapper: (
                    token: (c: { access_token: string }) => void
                ) => void;
            };
        };
    };
};

let PortalAllLayerInstance: EpfPortal | undefined = undefined;

let STATIC_EPF_ACCESS_TOKEN: string = '';

export const getEPFTokensBasedOnParams = () => {
    let tokens = undefined;
    try {
        if (PortalAllLayerInstance && PortalAllLayerInstance?.EPF?.THIRDPARTY?.TOKENS) {
            tokens = PortalAllLayerInstance.EPF.THIRDPARTY.TOKENS;
        } else {
            const current = new URL(window.location.href);
            if (current.searchParams && current.searchParams.has("__epftoken")) {
                console.log("getEPFTokensBasedOnParams href=", window.location.href);
                const userAgent = navigator.userAgent;
                const isSafari = userAgent.includes("Safari") && !userAgent.includes("Chrome");
                console.log("getEPFTokensBasedOnParams isSafari=", userAgent, isSafari);
                if (!!window?.HTML_RENDITION?.PortalAllLayerInstance) {
                    console.log("getEPFTokensBasedOnParams set Tokens from window?.HTML_RENDITION?.PortalAllLayerInstance=", window?.HTML_RENDITION?.PortalAllLayerInstance);
                    PortalAllLayerInstance = window?.HTML_RENDITION?.PortalAllLayerInstance
                    tokens = window?.HTML_RENDITION?.PortalAllLayerInstance?.EPF?.THIRDPARTY?.TOKENS;
                } else {
                    PortalAllLayerInstance = undefined;
                    tokens = undefined;
                }
            } 
        }
    } catch (error) {
        console.error("Error retrieving EPF token for getEPFTokensBasedOnParams:", error);
        tokens = undefined;
    }
    
    if (!tokens) {
        PortalAllLayerInstance = undefined;
        STATIC_EPF_ACCESS_TOKEN = '';
    } else {
        setStaticEpfAccessToken(tokens);
    }
    return tokens;
}

export const getEPFTokensForGeneral = () => {
    let tokens = undefined;
    try {
        tokens= getEPFTokensBasedOnParams();
    } catch (error) {
        console.error("Error retrieving EPF token for getEPFTokensForGeneral:", error);
        tokens = undefined;
    }
    return tokens;
}

const setStaticEpfAccessToken = async (tokens: any) => {
    if (!tokens || !PortalAllLayerInstance || !PortalAllLayerInstance?.EPF?.THIRDPARTY?.TOKENS) {
        STATIC_EPF_ACCESS_TOKEN = '';
        return;
    }

    if (PortalAllLayerInstance && PortalAllLayerInstance?.EPF?.THIRDPARTY?.TOKENS) {
        const token: any = await new Promise((resolve) => {
            PortalAllLayerInstance?.EPF.THIRDPARTY.TOKENS.tokenWrapper(resolve);
        });
        if (token && token?.access_token) {
            STATIC_EPF_ACCESS_TOKEN = token?.access_token;
        }
    }
}

export const fetchWithToken = async (input: any, init: any) => {
    try {
        const epfAccessToken = await getEPFAccessToken();
        if (isEmpty(epfAccessToken)) {
            console.log(`fetch without token... ${input}`);
            return fetch(input, init);
        }

        const options = merge(
            init,
            {
                headers: {
                    'Authorization': `bearer ${epfAccessToken}`
                }
            }
        )
        return fetch(input, options);

    } catch (e) {
        console.log(`fetch without token... ${input}`)
        return fetch(input, init)
    }
}

export function getEPFAccessToken(): Promise<string | null> {
    return new Promise((resolve, reject) => {
        try {
            if (!PortalAllLayerInstance || !PortalAllLayerInstance?.EPF?.THIRDPARTY?.TOKENS) {
                getEPFTokensForGeneral();
            }
            const portal = PortalAllLayerInstance;
            if (portal && portal?.EPF?.THIRDPARTY?.TOKENS)
                portal.EPF.THIRDPARTY.TOKENS.tokenWrapper(
                    (c: { access_token: string }) => {
                        resolve(c.access_token);
                    }
                );
            else resolve(null);
        } catch (e) {
            reject(e);
        }
    });
}

export const getStaticEPFAccessToken = () => {
    return STATIC_EPF_ACCESS_TOKEN;
}
